import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import DeepLinkFallback from './pages/DeepLinkFallback';
import AccountDeletion from './pages/AccountDeletion';
import Partners from './pages/Partners';

import Trips from './pages/Trips';
import TripDetail from './pages/TripDetail';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/account-deletion" element={<AccountDeletion />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/trips" element={<Trips />} />
        <Route path="/trips/:slug" element={<TripDetail />} />
        
        {/* Deep link fallback routes */}
        <Route path="/attraction/:id" element={<DeepLinkFallback />} />
        <Route path="/artefact/:id" element={<DeepLinkFallback />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
